import { PERMISSION_KEY_PATTERN } from "./permission-key.js";
import { z } from "zod";
//#region src/resolved-app.ts
/**
* The per-app permission keys on a `GET /v1/apps` row (feature
* 2026-09-18-audience-bound-dp-token, D-6, D-12).
*
* core-api's `ResolvedApp` row gains `permissionKeys`: the permission keys the
* calling principal holds for that app, computed server-side by
* `AppVisibilityService` from the same resolver the mint uses. For a
* principal on the `all` policy it is the app's declared keys. The shell's
* `activeAppPermissionKeys` reads this field in place of decoding the
* session token's `appPermissions`, which the mint stops writing.
*
* The field is optional on the wire so a core-api that predates it still
* parses; a reader treats absence as no keys and gates off. That is the
* fail-closed direction: a missing field can only deny.
*
* Only this field is declared here. `ResolvedApp` itself is declared once, in
* core-api's `FixtureResolutionService`, and the shell reads the rest of the
* row as it does today.
*/
const resolvedAppPermissionKeysSchema = z.object({ permissionKeys: z.array(z.string().regex(PERMISSION_KEY_PATTERN)).readonly().optional().describe("Permission keys the caller holds for this app; absent from an older core-api.") });
/**
* Read `permissionKeys` off a `GET /v1/apps` row, failing closed.
*
* Returns the parsed keys when the row carries a well-formed field. Returns
* `[]` when the field is absent, when the row is not an object, or when any
* key fails `PERMISSION_KEY_PATTERN`; a malformed field never widens what a
* hosted app may do. Other keys on the row are ignored, so a caller passes the
* whole row.
*/
function permissionKeysOf(row) {
	const parsed = resolvedAppPermissionKeysSchema.safeParse(row);
	if (!parsed.success) return [];
	return parsed.data.permissionKeys ?? [];
}
//#endregion
export { permissionKeysOf, resolvedAppPermissionKeysSchema };

//# sourceMappingURL=resolved-app.js.map